import React, { useState, useMemo } from "react";
import { IonButton } from "@ionic/react";
import { useGameState, handleSearchAbilityDone } from "context/GameContext";
import Flip from "react-reveal/Flip";
// Css
import classes from "./SearchAbility.module.scss";

const SearchAbility: React.FC = () => {
  const [reveal, setReveal] = useState(false);
  const { chosenPlayerIndex, players, code } = useGameState();

  const roleImageSrc = useMemo(() => {
    if (chosenPlayerIndex) {
      const chosenPlayer = players.find(
        (player) => player.id === chosenPlayerIndex
      );
      if (chosenPlayer?.isLiberal)
        return "assets/img/board/membership-liberal.svg";
      return "assets/img/board/membership-fascist.svg";
    }
  }, [chosenPlayerIndex, players]);

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>Search Session</h2>
      <div className={classes.wrapper}>
        <Flip left spy={reveal}>
          {reveal ? (
            <img className={classes.envelope} src={roleImageSrc} alt="" />
          ) : (
            <img
              className={classes.envelope}
              src="assets/img/board/party-membership.svg"
              alt=""
            />
          )}
        </Flip>
      </div>
      <p className={classes.description}>
        If you are the enacting president, click on the reveal button to see
        chosen player's role.
      </p>
      {reveal ? (
        <IonButton size="small" onClick={() => handleSearchAbilityDone(code)}>
          done
        </IonButton>
      ) : (
        <IonButton size="small" onClick={() => setReveal(true)}>
          reveal
        </IonButton>
      )}
    </div>
  );
};

export default SearchAbility;
